<template>
    <div class="documentation flex items-start w-full" v-if="isMounted">
        <div class="w-full" v-if="newVersion">
            <NavBar :nav-items="nav" />
            <router-view :jsonData="json"></router-view>
        </div>
        <div class="w-full" v-else>
            <div ref="test" class="swaggers" id="swagger"></div>
        </div>
    </div>
</template>

<script>
import send from "@/utils/fetch";
import ErrorHandler from "@/utils/errorHandler"
import NavBar from './components/navbar/Navbar'
import Main from './view/Main'
import {mixins} from './mixins'

export default {
    mixins: [mixins],
    data() {
        return {
            isMounted: false,
            nav: [],
            hash: '',
            jsonData: {},
            json: {},
            newVersion: true,
        }
    },

    components: {
        NavBar,
        Main
    },

    watch: {
        '$route.params'() {
            this.sendDataToComponent()
        }
    },

    methods: {
        _createPath(name) {
            const arr = name.split('/')
            return arr[arr.length -1]
        },

        redirectToFirstPath() {
            const path = this.$route.path.split('/').filter(item => item).join('/')
            const regExp = new RegExp(`(documentation\/${this.hash})(\/|)$`).test(`/${path}`)
            if (regExp) {
                const apiName = Object.keys(this.jsonData.paths)[0]
                const method = Object.keys(this.jsonData.paths[apiName])[0]
                this.$router.push(`/${path}/${apiName.split('/')[apiName.split('/').length -1]}/${method}`)
            }
        },

        isNewVersion() {
            const path = this.$route.path.split('/').filter(item => item).join('/')
            if (path) {
                return  path !== `documentation/${this.hash}`
            }
        },

        createNavMenu() {
            try {
                const navigationArray = []
                Object.keys(this.jsonData.paths).map(path => {
                    Object.keys(this.jsonData.paths[path]).map(method => {
                        navigationArray.push({
                            method,
                            url: `/documentation/${this.hash}/${this._createPath(path)}/${method}`,
                            name: this.jsonData.paths[path][method].info.title
                        })
                    })
                })
                this.nav = navigationArray
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        sendDataToComponent() {
            try {
                const params = this.$route.params
                if (params.api && params.method) {
                    Object.keys(this.jsonData.paths).map(key => {
                        if (new RegExp(params.api).test(key)) {
                            this.json = {[key]: {[params.method]: this.jsonData.paths[key][params.method]}}
                        }
                    })
                }
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async isAuth() {
            try {
                const params = {
                    "X-Secret-Key": this.hash
                }
                return await send(this.$url.checkAuth['check-secret-key'], 'POST', {params}).then(response => response.data.success)
            } catch (e) {
                location.href = 'https://www.google.com/'
            }
        }
    },

    async mounted() {
        try {
            this.hash = this.$route.params.hash
            this.newVersion = this.isNewVersion()
            const isAuth = await this.isAuth()

            if (isAuth) {
                this.jsonData = await import('./api.json')

                if (this._isEmptyObject(this.jsonData)) {
                    this.createNavMenu()
                    this.sendDataToComponent()
                }

                this.isMounted = true
            }
        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.documentation {
    .router-link-exact-active {
        background-color: rgba(var(--vs-primary), 1);
        color: white;
        border-radius: 4px;
        span {
            color: white !important;
        }
    }
}
</style>
